if (!customElements.get('tf-product-panels')) {
  customElements.define('tf-product-panels', class extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia('(max-width: 989px)');
      this.arrange = this.arrange.bind(this);
      this.media.addEventListener('change', this.arrange);
      this.frame = requestAnimationFrame(() => {
        this.panels = Array.from(this.children);
        this.arrange();
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.media?.removeEventListener('change', this.arrange);
    }

    arrange() {
      if (!this.panels) return;
      const key = this.media.matches ? 'mobilePosition' : 'desktopPosition';
      const sorted = [...this.panels].sort((a, b) => Number(a.dataset[key] || 10) - Number(b.dataset[key] || 10));
      sorted.forEach((panel, index) => {
        if (this.children[index] !== panel) this.insertBefore(panel, this.children[index] || null);
      });
      const purchase = this.querySelector('.tf-product-purchase');
      const features = purchase?.querySelector('.tf-product-features');
      const controls = purchase?.querySelector('.tf-product-controls');
      if (!features || !controls) return;
      const position = this.media.matches ? purchase.dataset.mobileFeatures : purchase.dataset.desktopFeatures;
      const first = ['right', 'below', 'after'].includes(position) ? controls : features;
      if (purchase.firstElementChild !== first) purchase.insertBefore(first, purchase.firstElementChild);
    }
  });
}
